if(typeof BackInStock !== 'function' ){
    class BackInStock extends HTMLElement {
        
        constructor() {
            super();
            this.HTMLElements = {
                ping_pong_back_in_stock_success: this.parentElement.querySelector('.ping_pong_back_in_stock_success'),
                ping_pong_back_in_stock_error: this.parentElement.querySelector('.ping_pong_back_in_stock_error'),
                ping_pong_back_in_stock_not_logged_in: this.parentElement.querySelector('.ping_pong_back_in_stock_not_logged_in'),
                ping_pong_back_in_stock_subscribe_container :this.parentElement.querySelector('.ping_pong_back_in_stock_subscribe_container')
            }
            
            // container
            this.container = this.parentElement.querySelector('.ping_pong_back_in_stock_container');

            // ping pong send form not logged in
            this.ping_pong_back_in_stock_not_logged_in_form = this.HTMLElements.ping_pong_back_in_stock_not_logged_in.querySelector('#ping_pong_back_in_stock_form');

            // ping pong back in stock not logged in exit
            this.ping_pong_back_in_stock_not_logged_in_exit = this.HTMLElements.ping_pong_back_in_stock_not_logged_in.querySelector('.ping_pong_back_in_stock_not_logged_in_exit');      

            // ping pong subscribe 
            this.ping_pong_back_in_stock_subscribe = this.HTMLElements.ping_pong_back_in_stock_subscribe_container.querySelector('.ping_pong_back_in_stock_subscribe')
            this.ping_pong_back_in_stock_delete_subscriptions = this.HTMLElements.ping_pong_back_in_stock_subscribe_container.querySelector('.ping_pong_back_in_stock_delete_subscriptions')
            this.ping_pong_back_in_stock_select = this.ping_pong_back_in_stock_not_logged_in_form.querySelector('.ping_pong_back_in_stock_select');
            this.ping_pong_back_in_stock_select_contact = this.ping_pong_back_in_stock_not_logged_in_form.querySelector('.ping_pong_back_in_stock_select_contact');
            this.ping_pong_back_in_stock_phone = this.ping_pong_back_in_stock_not_logged_in_form.querySelector('.ping_pong_back_in_stock_phone');
            this.button = this.ping_pong_back_in_stock_not_logged_in_form.querySelector('button[type="submit"]');

            this.locations = []
            window.addEventListener('load', () => {
                this.init();
            });
        }
        
        async init() {
            await this.waitForCurrentVariantReady();
            this.addListeners();

            const locations = await this.fetchLocations()
            this.locations = locations;
            this.populateScrollDown(locations);
            this.verifySubscriptions();
        }
        waitForCurrentVariantReady() {
            return new Promise((resolve) => {
                const check = () => {
                    const productVariantsElement = document.querySelector('product-variants');
                    
                    if (productVariantsElement?.currentVariant) {
                        this.productVariantsElement = productVariantsElement;
                        resolve();
                        return true;
                    }
                    return false;
                }

                if (check()) return;

                const interval = setInterval(() => {
                    if (check()) clearInterval(interval);
                }, 100);
            });
        }

        populateScrollDown(locations) {
            if(!locations) {
                return;
            }

            locations.forEach((location) => {
                const option = document.createElement('option');
                option.value = location.node.name
                option.innerText = location.node.name;
                this.ping_pong_back_in_stock_select.appendChild(option);

                if(this.getAttribute('data-preferred-location') === location.node.id.replace("gid://shopify/Location/", "")) {
                    option.selected = true;
                }
            });

        }

        addListeners() {
            this.productVariantsElement.addEventListener('VARIANT_CHANGE', this.onVariantChange.bind(this));
            this.ping_pong_back_in_stock_subscribe.addEventListener('click', this.openEmailModal.bind(this));
            this.ping_pong_back_in_stock_delete_subscriptions.addEventListener('click', this.onDelete.bind(this));

            this.ping_pong_back_in_stock_not_logged_in_exit.addEventListener('click', this.closeEmailModal.bind(this));
            this.ping_pong_back_in_stock_not_logged_in_form.addEventListener('submit', this.sendForm.bind(this));
            this.ping_pong_back_in_stock_select_contact.addEventListener('change', this.addInput.bind(this));
        }

        addInput(e) {
            const value = e.target.value;
            if(value === "sms") {
                this.ping_pong_back_in_stock_phone.setAttribute('required', '');
                this.ping_pong_back_in_stock_phone.style.display = "block";
                this.button.innerText = window.KROWN.settings.locales.ping_pong_sms_text;
   
            } else {
                this.ping_pong_back_in_stock_phone.style.display = "none";
                this.ping_pong_back_in_stock_phone.removeAttribute('required');
                this.button.innerText = window.KROWN.settings.locales.ping_pong_email_text;
            }
            e.preventDefault();
        }

        
        onVariantChange(e) {
            this.verifySubscriptions();
        }

        hideAll() {
            Object.keys(this.HTMLElements).forEach((key) => {
                if (this.HTMLElements[key] && this.HTMLElements[key].style) {
                    this.HTMLElements[key].style.display = "none";
                }
            });
        }

        async sendForm(e) {
            e.preventDefault();

            const form = e.target;
            const formData = new FormData(form);
            const email = formData.get('email');
            const contactMethod = formData.get('contact_method');
            const phone = formData.get('phone');

            const locationName = this.ping_pong_back_in_stock_select.value;
            const variantId = this.productVariantsElement.currentVariant.id;
            
            const url = `/apps/proxy/pingpongsubscribeloggedout`;
            
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Control-Allow-Origin': '*',
                },
                body: JSON.stringify({
                    email: email,
                    phone: phone === "" ? null : phone.toString(),
                    contactMethod: contactMethod,
                    variantId: variantId,
                    locationName: locationName,
                }),
            });
            
            if(!response.ok) {
                this.showError();
                return;
            }
            
            const data = await response.json();

            const success = this.HTMLElements.ping_pong_back_in_stock_success.querySelector('p');
            if(contactMethod === "sms") {
                success.innerText = window.KROWN.settings.locales.ping_pong_sms_sucess;
            } else {
                success.innerText = window.KROWN.settings.locales.ping_pong_email_sucess;
            }
            if(this.getAttribute('data-email') !== "") {
                this.setAttribute('data-subscriptions', JSON.stringify(data.subscriptions.variantes));
            }
            this.showSuccess();
        }

        async verifySubscriptions() {
            if (!this.productVariantsElement?.currentVariant) {

                return;
            }
            const subscriptions = this.getAttribute('data-subscriptions');
            const parsedSubscriptions = subscriptions === "" ? [] : JSON.parse(subscriptions);

            
            const variantId = this.productVariantsElement.currentVariant.id;
            this.hideAll();
            if(!this.productVariantsElement.currentVariant.available) {

                this.container.style.display = "block";
                this.HTMLElements.ping_pong_back_in_stock_subscribe_container.style.display = "flex";
                if(parsedSubscriptions.includes(Number(variantId))) {
                    this.ping_pong_back_in_stock_subscribe.style.display = "none";
                    this.ping_pong_back_in_stock_delete_subscriptions.style.display = "flex";
                } else {
                    this.ping_pong_back_in_stock_delete_subscriptions.style.display = "none";
                    this.ping_pong_back_in_stock_subscribe.style.display = "flex";
                }
            } else {
                this.container.style.display = "none";
            }
        }

        async fetchLocations() {
            const token = window.KROWN.settings.storefront_api_key;
            const domain = window.KROWN.settings.store_domain;
            
            const query = `#graphql
                query {
                    locations(first: 250) {
                        edges {
                            node {
                                id
                                name
                            }
                        }
                    }
                }
            `
            
            const body = {
                query: query,
            }
            const response = await fetch(`https://${domain}/api/2024-10/graphql.json`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': token
                },
                body: JSON.stringify(body),

            });
            
            if(!response.ok) {
                this.showError();
                return;
            }
            const data = await response.json();

            const sortedLocations = data.data.locations.edges.sort((a, b) => a.node.name.localeCompare(b.node.name));
            return sortedLocations;
            
        }

        closeEmailModal() {

            this.HTMLElements.ping_pong_back_in_stock_not_logged_in.style.display = "none";
            this.verifySubscriptions();
            this.container.style.display = "block";
        }

        openEmailModal() {
            this.hideAll();
            this.container.style.display = "none";
            this.HTMLElements.ping_pong_back_in_stock_not_logged_in.style.display = "flex";
            this.verifyLocationsAvailability();
        }

        async verifyLocationsAvailability() {
            const productId = this.getAttribute('product-id');
            
            const variantId = this.productVariantsElement.currentVariant.id;

            const token = window.KROWN.settings.storefront_api_key;
            
            const domain = window.KROWN.settings.store_domain;
            const query = `#graphql
                query {
                    product(id: "gid://shopify/Product/${productId}") {
                        id
                        title
                        variants(first: 250) {
                            nodes{
                                id
                                quantityAvailable
                                storeAvailability(first: 250) {
                                    nodes{
                                        available
                                        location{
                                            name
                                        }
                                        quantityAvailable
                                    }
                                }
                                title
                            }
                        }
                    }
                }
            `

            const body = {
                query: query,
            }
            const response = await fetch(`https://${domain}/api/2025-01/graphql.json`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': token
                },
                body: JSON.stringify(body),

            });

            if(!response.ok) {
                this.showError();
                return;
            }

            const data = await response.json();
            if(!data.data.product) {
                return;
            }

            const locations = data.data.product.variants.nodes.find((variant) => variant.id === `gid://shopify/ProductVariant/${variantId}`).storeAvailability.nodes;
            
            this.disableAvailableLocations(locations);
        }

        disableAvailableLocations(locations) {
            const options = this.ping_pong_back_in_stock_select.querySelectorAll('option');

            
            options.forEach((option, index) => {
                option.disabled = false;
                option.style.display = "block";
                const location = locations.find((location) => location.location.name === option.value);
                if(location && location.available) {
                    option.disabled = true;
                    option.style.display = "none";
                } else {
                    option.disabled = false;
                }
            });
        }

        async onDelete(e) {
            e.preventDefault();
            const customerId = this.getAttribute('data-customer-id');
            const variantId = this.productVariantsElement.currentVariant.id;
            const subscriptions = this.getAttribute('data-subscriptions');

            const url = `/apps/proxy/pingpongunsubscribeonline`;

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Control-Allow-Origin': '*',
                },
                body: JSON.stringify({
                    customerId: customerId,
                    variantId: variantId,
                    subscriptions: {variantes: JSON.parse(subscriptions)},
                }),
            });
            if(!response.ok) {
                this.showError();
                return;
            }

            let newSubscriptions = JSON.parse(subscriptions);
            newSubscriptions = newSubscriptions.filter((sub) => sub !== Number(variantId));
            this.setAttribute('data-subscriptions', JSON.stringify(newSubscriptions));
            this.verifySubscriptions();
        }

        showSuccess() {
            this.hideAll();
            this.container.style.display = "block";
            this.HTMLElements.ping_pong_back_in_stock_success.style.display = "block";

            setTimeout(() => {
                this.verifySubscriptions();
            }, 2000);
        }

        showError() {
            this.hideAll();
            this.container.style.display = "block";
            this.HTMLElements.ping_pong_back_in_stock_error.style.display = "block";
        }
    }
    customElements.define('back-in-stock', BackInStock);
}